// extracted by mini-css-extract-plugin
export default {"descriptionContainer":"SerieItemDetail_descriptionContainer__ES60R","packageDescription":"SerieItemDetail_packageDescription__-bwAD","container":"SerieItemDetail_container__f74a4"};